import { formatDistanceToNow } from "date-fns";
import { GitMerge } from "lucide-react";
import type { JobMergeRecord } from "@/lib/api/mailbox";

const POLICY_LABELS: Record<string, string> = {
  manual: "Merged by a person",
  ask: "Approved by the owner",
  auto: "Merged automatically",
};

/** Who approved a merge, in plain words ("policy:auto" → the project's auto policy). */
function approverText(record: JobMergeRecord): string {
  return record.approverLabel === "policy:auto" ? "the project's auto-merge policy" : record.approverLabel;
}

/**
 * ENG-347: the pull requests merged through CompBox for this run — the PR, how
 * the merge was allowed (manual / ask / auto), who approved it and when.
 */
export function MergeLog({ records }: { records: JobMergeRecord[] }) {
  if (records.length === 0) return null;
  return (
    <div data-testid="merge-log">
      <h3 className="text-sm font-semibold mb-2 flex items-center gap-1.5">
        <GitMerge className="h-4 w-4" />
        Merges
      </h3>
      <ul className="space-y-1.5 text-sm">
        {records.map((record) => (
          <li key={record.id} data-testid="merge-record" className="flex flex-wrap items-center gap-x-2 gap-y-0.5">
            <a href={record.prUrl} target="_blank" rel="noreferrer" className="font-medium underline-offset-2 hover:underline">
              {record.repoFullName}#{record.prNumber}
            </a>
            <span className="text-muted-foreground">
              {POLICY_LABELS[record.policy] ?? record.policy} · approved by {approverText(record)} ·{" "}
              {formatDistanceToNow(new Date(record.createdAt), { addSuffix: true })}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
